import React, { useEffect, useRef, useState } from "react";
import * as d3 from "d3";
import styles from "./styles.module.scss";
import STATISTIC_TYPES from "../STATISTIC_TYPES";
import formatNumber from "../../utils/formatNumber";
import ChartNote from "../ChartNote";
import { FIND_STATISTIC_TYPE_BY_VALUE } from "../STATISTIC_TYPES";

const MOCK_DATA = [
    {
        name: "30年或以上",
        data: [
            {
                name: "3萬元~未滿5萬元",
                value: "352.3521",
            },
            {
                name: "沒有收入",
                value: "30.6593",
            },
            {
                name: "5萬元~未滿7萬元",
                value: "275.8498",
            },
            {
                name: "9萬元~未滿11萬元",
                value: "181.9893",
            },
            {
                name: "11萬元~未滿13萬元",
                value: "47.3158",
            },
            {
                name: "不到1萬元",
                value: "127.5975",
            },
            {
                name: "7萬元~未滿9萬元",
                value: "162.3350",
            },
            {
                name: "1萬元~未滿3萬元",
                value: "357.3531",
            },
            {
                name: "25萬元及以上",
                value: "38.7274",
            },
            {
                name: "15萬元~未滿20萬元",
                value: "65.7376",
            },
            {
                name: "20萬元~未滿25萬元",
                value: "27.5823",
            },
            {
                name: "13萬元~未滿15萬元",
                value: "30.0370",
            },
        ],
    },
    {
        name: "10~未滿20年",
        data: [
            {
                name: "3萬元~未滿5萬元",
                value: "74.8112",
            },
            {
                name: "沒有收入",
                value: "4.1704",
            },
            {
                name: "5萬元~未滿7萬元",
                value: "96.5186",
            },
            {
                name: "9萬元~未滿11萬元",
                value: "57.2742",
            },
            {
                name: "11萬元~未滿13萬元",
                value: "20.4527",
            },
            {
                name: "不到1萬元",
                value: "5.2213",
            },
            {
                name: "7萬元~未滿9萬元",
                value: "44.6203",
            },
            {
                name: "1萬元~未滿3萬元",
                value: "48.9373",
            },
            {
                name: "25萬元及以上",
                value: "17.2101",
            },
            {
                name: "15萬元~未滿20萬元",
                value: "25.6557",
            },
            {
                name: "20萬元~未滿25萬元",
                value: "7.1517",
            },
            {
                name: "13萬元~未滿15萬元",
                value: "7.3858",
            },
        ],
    },
    {
        name: "5~未滿10年",
        data: [
            {
                name: "3萬元~未滿5萬元",
                value: "42.4421",
            },
            {
                name: "沒有收入",
                value: "1.0298",
            },
            {
                name: "5萬元~未滿7萬元",
                value: "52.6348",
            },
            {
                name: "9萬元~未滿11萬元",
                value: "28.0404",
            },
            {
                name: "11萬元~未滿13萬元",
                value: "7.7926",
            },
            {
                name: "不到1萬元",
                value: "2.3194",
            },
            {
                name: "7萬元~未滿9萬元",
                value: "23.5205",
            },
            {
                name: "1萬元~未滿3萬元",
                value: "13.2488",
            },
            {
                name: "25萬元及以上",
                value: "4.0856",
            },
            {
                name: "15萬元~未滿20萬元",
                value: "2.0980",
            },
            {
                name: "20萬元~未滿25萬元",
                value: "0.0000",
            },
            {
                name: "13萬元~未滿15萬元",
                value: "2.6809",
            },
        ],
    },
    {
        name: "20~未滿30年",
        data: [
            {
                name: "3萬元~未滿5萬元",
                value: "113.8053",
            },
            {
                name: "沒有收入",
                value: "1.5152",
            },
            {
                name: "5萬元~未滿7萬元",
                value: "121.6981",
            },
            {
                name: "9萬元~未滿11萬元",
                value: "59.8294",
            },
            {
                name: "11萬元~未滿13萬元",
                value: "8.0078",
            },
            {
                name: "不到1萬元",
                value: "11.3359",
            },
            {
                name: "7萬元~未滿9萬元",
                value: "66.4477",
            },
            {
                name: "1萬元~未滿3萬元",
                value: "56.6574",
            },
            {
                name: "25萬元及以上",
                value: "26.3804",
            },
            {
                name: "15萬元~未滿20萬元",
                value: "30.8857",
            },
            {
                name: "20萬元~未滿25萬元",
                value: "14.8687",
            },
            {
                name: "13萬元~未滿15萬元",
                value: "27.7512",
            },
        ],
    },
    {
        name: "3~未滿5年",
        data: [
            {
                name: "3萬元~未滿5萬元",
                value: "20.8733",
            },
            {
                name: "沒有收入",
                value: "3.3769",
            },
            {
                name: "5萬元~未滿7萬元",
                value: "16.0345",
            },
            {
                name: "9萬元~未滿11萬元",
                value: "10.7748",
            },
            {
                name: "11萬元~未滿13萬元",
                value: "9.7768",
            },
            {
                name: "不到1萬元",
                value: "3.3725",
            },
            {
                name: "7萬元~未滿9萬元",
                value: "2.3225",
            },
            {
                name: "1萬元~未滿3萬元",
                value: "2.1366",
            },
            {
                name: "25萬元及以上",
                value: "3.3214",
            },
            {
                name: "15萬元~未滿20萬元",
                value: "5.1096",
            },
            {
                name: "20萬元~未滿25萬元",
                value: "0.4965",
            },
            {
                name: "13萬元~未滿15萬元",
                value: "6.4508",
            },
        ],
    },
    {
        name: "1~未滿3年",
        data: [
            {
                name: "3萬元~未滿5萬元",
                value: "27.9237",
            },
            {
                name: "沒有收入",
                value: "0.3755",
            },
            {
                name: "5萬元~未滿7萬元",
                value: "12.9042",
            },
            {
                name: "9萬元~未滿11萬元",
                value: "15.6805",
            },
            {
                name: "11萬元~未滿13萬元",
                value: "4.7817",
            },
            {
                name: "不到1萬元",
                value: "5.3222",
            },
            {
                name: "7萬元~未滿9萬元",
                value: "10.9255",
            },
            {
                name: "1萬元~未滿3萬元",
                value: "7.9772",
            },
            {
                name: "25萬元及以上",
                value: "1.5682",
            },
            {
                name: "15萬元~未滿20萬元",
                value: "5.7697",
            },
            {
                name: "20萬元~未滿25萬元",
                value: "0.0000",
            },
            {
                name: "13萬元~未滿15萬元",
                value: "0.0000",
            },
        ],
    },
    {
        name: "不到1年",
        data: [
            {
                name: "3萬元~未滿5萬元",
                value: "3.2072",
            },
            {
                name: "沒有收入",
                value: "0.0000",
            },
            {
                name: "5萬元~未滿7萬元",
                value: "9.2648",
            },
            {
                name: "9萬元~未滿11萬元",
                value: "5.2057",
            },
            {
                name: "11萬元~未滿13萬元",
                value: "0.0000",
            },
            {
                name: "不到1萬元",
                value: "0.0000",
            },
            {
                name: "7萬元~未滿9萬元",
                value: "0.0000",
            },
            {
                name: "1萬元~未滿3萬元",
                value: "2.8171",
            },
            {
                name: "25萬元及以上",
                value: "0.0000",
            },
            {
                name: "15萬元~未滿20萬元",
                value: "1.7884",
            },
            {
                name: "20萬元~未滿25萬元",
                value: "1.4760",
            },
            {
                name: "13萬元~未滿15萬元",
                value: "1.4801",
            },
        ],
    },
    {
        name: "不記得",
        data: [
            {
                name: "3萬元~未滿5萬元",
                value: "0.0000",
            },
            {
                name: "沒有收入",
                value: "0.0000",
            },
            {
                name: "5萬元~未滿7萬元",
                value: "0.0000",
            },
            {
                name: "9萬元~未滿11萬元",
                value: "0.0000",
            },
            {
                name: "11萬元~未滿13萬元",
                value: "1.3211",
            },
            {
                name: "不到1萬元",
                value: "0.8194",
            },
            {
                name: "7萬元~未滿9萬元",
                value: "0.8580",
            },
            {
                name: "1萬元~未滿3萬元",
                value: "1.4752",
            },
            {
                name: "25萬元及以上",
                value: "0.0000",
            },
            {
                name: "15萬元~未滿20萬元",
                value: "0.0000",
            },
            {
                name: "20萬元~未滿25萬元",
                value: "0.0000",
            },
            {
                name: "13萬元~未滿15萬元",
                value: "0.0000",
            },
        ],
    },
];

const ORDERS = [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    "AA",
    "AB",
    "AC",
    "AD",
    "AE",
    "AF",
    "AG",
    "AH",
    "AI",
    "AJ",
    "AK",
    "AL",
    "AM",
    "AN",
    "AO",
    "AP",
    "AQ",
    "AR",
    "AS",
    "AT",
    "AU",
    "AV",
    "AW",
    "AX",
    "AY",
    "AZ",
];

function HeatmapChart({
    data = MOCK_DATA,
    statisticsType,
    chartTitle,
    chart2Title,
    chart3Title,
    chartNote,
}) {
    const svgRef = useRef(null);
    const containerRef = useRef(null);
    const [hasLongLabel, setHasLongLabel] = useState(false);
    const [labelMap, setLabelMap] = useState(null);
    const labelMapRef = useRef(null);
    const tooltipRef = useRef(null);

    useEffect(() => {
        if (!data || !svgRef.current) return;

        // 清除現有的圖表
        d3.select(svgRef.current).selectAll("*").remove();

        // 過濾掉空值並進行安全性檢查
        const filteredData = data.filter(
            (item) =>
                item &&
                item.data &&
                Array.isArray(item.data) &&
                item.data.length > 0 &&
                item.data.every((d) => d && d.name && d.value)
        );

        if (filteredData.length === 0 || !filteredData[0].data) {
            setHasLongLabel(false);
            setLabelMap(null);
            return;
        }

        // 檢查是否有超過20字的標籤
        const hasLongLabelCheck = filteredData[0].data.some(
            (item) => item.name && item.name.length > 20
        );

        console.log("HAS LONG LABEL CHECK", hasLongLabelCheck);

        // 更新狀態
        setHasLongLabel(hasLongLabelCheck);

        // 如果有長標籤，創建字母標籤映射
        const newLabelMap = hasLongLabelCheck
            ? Object.fromEntries(
                  filteredData[0].data.map((item, index) => [
                      item.name,
                      String.fromCharCode(65 + index),
                  ])
              )
            : null;

        setLabelMap(newLabelMap);
        labelMapRef.current = newLabelMap;

        // 設定圖表尺寸和邊距
        const maxLabelLength = filteredData.reduce((max, item) => {
            return Math.max(max, (item.name || "").length);
        }, 0);

        // 如果有標籤超過20字元,左邊距設為200,否則維持140
        const leftMargin = maxLabelLength > 15 ? 200 : 140;
        const margin = { top: 60, right: 120, bottom: 100, left: leftMargin };
        const width =
            Math.min(window.innerWidth, 1440) -
            180 -
            180 -
            margin.left -
            margin.right;

        // 修改：計算動態高度
        const cellHeight = 44; // 每個格子固定高度為40px
        const totalRows = filteredData.length; // 總行數
        const height = cellHeight * totalRows; // 根據行數計算總高度

        // 創建SVG
        const svg = d3
            .select(svgRef.current)
            .attr("width", width + margin.left + margin.right)
            .attr("height", height + margin.top + margin.bottom)
            .append("g")
            .attr("transform", `translate(${margin.left},${margin.top})`);

        // 處理數據
        const subCategories = filteredData[0].data.map((d) => d.name);
        const majorCategories = filteredData.map((d) => d.name);

        // 修改y軸比例尺
        const y = d3
            .scaleBand()
            .range([height, 0])
            .domain(majorCategories)
            .padding(0.05);

        // 創建比例尺
        const x = d3
            .scaleBand()
            .range([0, width])
            .domain(subCategories)
            .padding(0.05);

        // 修改顏色比例尺
        const maxValue = d3.max(filteredData, (d) =>
            d3.max(d.data, (v) => +v.value)
        );
        const colorScale = d3
            .scaleSequential()
            .interpolator(
                d3.interpolate("#FAECFF", "#1B0937") // 從淺色到深色
            )
            .domain([0, maxValue]);

        // 添加X軸
        svg.append("g")
            .attr("transform", `translate(0,${height})`)
            .call(d3.axisBottom(x))
            .selectAll("text")
            .attr("transform", `translate(0,${10}) rotate(-24)`)
            .style("text-anchor", "end")
            .style("font-size", "14px")
            .each(function (d) {
                const text = d3.select(this);

                if (!d) {
                    text.text(d);
                    return;
                }

                // 如果有長標籤，使用字母標籤
                if (hasLongLabelCheck) {
                    text.text(labelMapRef.current[d] || d)
                        .style("font-weight", "bold")
                        .style("fill", "#2c3e50");
                } else if (d.length > 11) {
                    const words = d.match(/.{1,10}/g);
                    text.text("")
                        .selectAll("tspan")
                        .data(words)
                        .enter()
                        .append("tspan")
                        .text((d) => d)
                        .attr("x", 0)
                        .attr("dy", (d, i) => (i === 0 ? 0 : "1em"));
                } else {
                    text.text(d);
                }
            });

        // 添加Y軸
        svg.append("g")
            .call(d3.axisLeft(y))
            .selectAll("text")
            .each(function (d) {
                // 檢查所有標籤中是否有文字量超過5
                const hasLongText = y
                    .domain()
                    .some((label) => label.length > 10);
                const fontSize = hasLongText ? "10px" : "14px";

                const text = d3.select(this).style("font-size", fontSize);

                if (d.includes("年") && d.includes("(")) {
                    // 處理 "25~33年(民國79~87年興建)" 格式
                    const [yearPart, bracketPart] = d.split("(");
                    text.text("")
                        .append("tspan")
                        .text(yearPart)
                        .attr("x", -10)
                        .attr("dy", 0);
                    text.append("tspan")
                        .text("(" + bracketPart)
                        .attr("x", -10)
                        .attr("dy", "1.2em");
                } else {
                    if (d.length > 11) {
                        const lines = [];
                        for (let i = 0; i < d.length; i += 10) {
                            lines.push(d.slice(i, i + 10));
                        }
                        text.text("");
                        lines.forEach((line, i) => {
                            text.append("tspan")
                                .text(line)
                                .attr("x", -10)
                                .attr("dy", i === 0 ? 0 : "1.2em");
                        });
                    } else {
                        text.text(d);
                    }
                }
            });

        // 創建tooltip
        const tooltip = d3.select(tooltipRef.current);

        // 繪製熱力圖方格
        filteredData.forEach((majorCategory) => {
            majorCategory.data.forEach((item) => {
                const value = +item.value;

                const tooltipContent = chart3Title
                    ? `${chart2Title}：${majorCategory.name}\n${chart3Title}：${
                          hasLongLabelCheck
                              ? `${labelMapRef.current[item.name]} (${
                                    item.name
                                })`
                              : item.name
                      }\n${chartTitle}的${
                          FIND_STATISTIC_TYPE_BY_VALUE(statisticsType).label
                      }：${
                          statisticsType === STATISTIC_TYPES.百分比.value
                              ? `${Math.round(value) * 100}%`
                              : statisticsType === STATISTIC_TYPES.平均數.value
                              ? value.toFixed(1)
                              : Math.round(value)
                      }`
                    : `${chartTitle}：${majorCategory.name}\n${chart2Title}：${
                          hasLongLabelCheck
                              ? `${labelMapRef.current[item.name]} (${
                                    item.name
                                })`
                              : item.name
                      }\n${chartTitle}的${
                          FIND_STATISTIC_TYPE_BY_VALUE(statisticsType).label
                      }：${formatNumber(
                          value,
                          FIND_STATISTIC_TYPE_BY_VALUE(statisticsType).value
                      )}`;

                console.log("TOOLTIP CONTENT", tooltipContent);

                svg.append("rect")
                    .attr("x", x(item.name))
                    .attr("y", y(majorCategory.name))
                    .attr("width", x.bandwidth())
                    .attr("height", y.bandwidth())
                    .attr("fill", colorScale(value))
                    .attr("stroke", "white")
                    .attr("stroke-width", 1)
                    .on("mouseenter", function (event) {
                        const mousePosition = d3.mouse(this);
                        console.log("MOUSE POSITION", mousePosition);
                        tooltip.style("opacity", 1);
                        tooltip
                            .html(tooltipContent)
                            .style(
                                "left",
                                mousePosition[0] + margin.left + 10 + "px"
                            )
                            .style("top", mousePosition[1] + margin.top + "px");
                    })
                    .on("mousemove", function (event) {
                        const mousePosition = d3.mouse(this);
                        tooltip.style("opacity", 1);
                        tooltip
                            .style(
                                "left",
                                mousePosition[0] + margin.left + 10 + "px"
                            )
                            .style("top", mousePosition[1] + margin.top + "px");
                    })

                    .on("mouseout", function () {
                        tooltip.style("opacity", 0);
                    });
            });
        });

        // 添加顏色圖例
        const legendWidth = 20;
        const legendHeight = height;
        const legend = svg
            .append("g")
            .attr("transform", `translate(${width + 20}, 0)`);

        const legendScale = d3
            .scaleLinear()
            .domain([
                0,
                statisticsType === STATISTIC_TYPES.百分比.value
                    ? 100
                    : maxValue,
            ])
            .range([legendHeight, 0])
            .nice();

        const defs = svg.append("defs");
        const linearGradient = defs
            .append("linearGradient")
            .attr("id", "linear-gradient")
            .attr("x1", "0%")
            .attr("y1", "100%")
            .attr("x2", "0%")
            .attr("y2", "0%");

        linearGradient
            .selectAll("stop")
            .data(d3.range(0, 1.1, 0.1))
            .enter()
            .append("stop")
            .attr("offset", (d) => d * 100 + "%")
            .attr("stop-color", (d) => colorScale(d * maxValue));

        legend
            .append("rect")
            .attr("width", legendWidth)
            .attr("height", legendHeight)
            .style("fill", "url(#linear-gradient)");

        legend
            .append("g")
            .attr("transform", `translate(${legendWidth}, 0)`)
            .call(
                d3
                    .axisRight(legendScale)
                    .ticks(5)
                    .tickFormat((d) =>
                        statisticsType === STATISTIC_TYPES.百分比.value
                            ? d + "%"
                            : d
                    )
            );

        let legendLabel = "";
        if (statisticsType === STATISTIC_TYPES.中位數.value) {
            legendLabel = "中位數";
        } else if (statisticsType === STATISTIC_TYPES.平均數.value) {
            legendLabel = "平均數";
        } else if (statisticsType === STATISTIC_TYPES.百分比.value) {
            legendLabel = "百分比";
        } else if (statisticsType === STATISTIC_TYPES.實際數.value) {
            legendLabel = "計數";
        }

        legend
            .append("text")
            .attr("transform", "rotate(90)")
            .attr("x", legendHeight / 2)
            .attr("y", -legendWidth - 40)
            .style("text-anchor", "middle")
            .style("font-size", "14px")
            .text(legendLabel);
    }, [data]);

    return (
        <div ref={containerRef} className={styles.container}>
            {hasLongLabel && labelMap ? (
                <div className={styles.labelMap}>
                    {Object.entries(labelMap).map(
                        ([originalText, letter], index) => (
                            <div key={index}>
                                {letter} ： {originalText}
                            </div>
                        )
                    )}
                </div>
            ) : null}
            <div className={styles.chartContainer}>
                <div ref={tooltipRef} className={styles.tooltip}></div>
                <svg ref={svgRef}></svg>
            </div>

            {chartNote && <ChartNote chartNote={chartNote} />}
        </div>
    );
}

export default HeatmapChart;